import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { CommercialService } from "@app/commercial/services/commercial.service";
import { FormatsService } from "@app/commercial/services/formats.service";
import { ShareService } from "@app/shared/services/share.service";

@Component({
  selector: "app-commercial-report",
  templateUrl: "./report.component.html",
  styleUrls: ["./report.component.scss"],
})
export class ReportComponent implements OnInit {
  isInitializing = false;
  isUploading = false;
  globalError: string;
  uploadError: string;
  enterprises;
  data;

  formControl = this.formBuilder.group({
    typeDocument: ["", [Validators.required]],
    enterprise: ["", []],
    commercialManagement: ["", []],
    dateType: ["", []],
    startDate: ["", []],
    finishDate: ["", []],
  });

  constructor(
    private formBuilder: FormBuilder,
    private commercialService: CommercialService,
    private formatsService: FormatsService,
    private shareService: ShareService
  ) {
    this.commercialService.getEnterprises({ all: "ALL" }).subscribe(
      (data) => {
        this.enterprises = data["body"];
        this.isInitializing = false;
      },
      (error) => {
        this.globalError =
          "Se ha presentado un error, por favor vuelva a intentarlo";
        this.isInitializing = false;
      }
    );
  }

  ngOnInit(): void {}

  send() {
    this.globalError = "";
    this.uploadError = "";
    if (
      ((this.formControl.get("startDate").value ||
        this.formControl.get("finishDate").value) &&
        !this.formControl.get("dateType").value) ||
      ((!this.formControl.get("startDate").value ||
        !this.formControl.get("finishDate").value) &&
        this.formControl.get("dateType").value)
    ) {
      this.uploadError =
        "Debe ingresar tipo de fecha, fecha inicial y fecha final";
      return;
    } else if (
      !this.formControl.get("startDate").value &&
      !this.formControl.get("finishDate").value &&
      !this.formControl.get("enterprise").value &&
      !this.formControl.get("commercialManagement").value &&
      !this.formControl.get("dateType").value
    ) {
      this.uploadError = "Debe ingresar al menos un criterio de búsqueda";
      return;
    } else {
      let values = this.formControl.value;
      const enterprise = values.enterprise ? values.enterprise : undefined;
      const commercialManagement = values.commercialManagement
        ? values.commercialManagement
        : undefined;
      const dateType = values.dateType ? values.dateType : undefined;
      const startDate = values.startDate ? values.startDate : undefined;
      const finishDate = values.finishDate ? values.finishDate : undefined;
      this.commercialService
        .get({
          type: "R",
          enterprise,
          commercialManagement,
          dateType,
          startDate,
          finishDate,
        })
        .subscribe(
          (data) => {
            this.data = data["body"];
            this.isInitializing = false;
            if (!this.data.length) {
              this.uploadError = "No se encontraron resultados";
              return;
            }
            let content =
              this.formControl.value.typeDocument === "PDF"
                ? this.formatsService.generateReport(this.data)
                : this.shareService.getTitles(
                    this.formatsService.TRANSLATE,
                    this.data
                  );
            this.shareService.export(
              this.formControl.value.typeDocument,
              content,
              "Seguimiento comercial",
              {
                pageSize: "FOLIO",
                pageOrientation: "landscape",
                title: "Informe Seguimientos comerciales",
              }
            );
          },
          (error) => {
            this.uploadError =
              "Se ha presentado un error, por favor vuelva a intentarlo";
            this.isInitializing = false;
          }
        );
    }
  }
}
